<template>
  

<div class="viptc1">
        <van-popup v-model="mo1" :close-on-click-overlay='false'>
<div class="viptc" @click="tz('/user/vip?active=1&bgy')" >

</div>
<div  class="viptc_close">


<img src="/images/close.png" alt="" style="width:.2rem;height:.2rem" @click="close()">
</div>
</van-popup>
</div>


  </template>
  
  <style lang="less" scoped>
  .viptc_close{
    display: flex;
    justify-content: center;
  }
  </style>
  <script>
import Vue from 'vue';
import { Popup } from 'vant';
import global from './../views/common.vue'
Vue.use(Popup);

  export default {
    name: 'viptc',
    data() {
      return {
        backStatu:false,
        user:null,
        mo1:this.mo
      }
    },
    created(){
        let that=this;
        this.$axios.get(global.http+'/vip/user?openid='+localStorage.getItem('openid')).then((response) => {
            console.log(response.data);
         if(response.data!=null){
            response.data.vip=Number(response.data.vip);
  that.user=response.data;

if(that.user.vip<3){
    window.history.pushState('forward', null,'#');
 window.history.forward();
 window.onpopstate = function(event) {
that.mo1=true;
 }
}
         }else{
          
    window.history.pushState('forward', null,'#');
 window.history.forward();
 window.onpopstate = function(event) {
that.mo1=true;
 }



         }

    })







    },props: {
mo:{
    type:Boolean,
    default:false
}

}
    ,methods:{

        close(){
    let that=this;
    that.mo1=false;

},tz(val){
    console.log(111);
this.$router.push(val)
}
    }  
    

    ,beforeRouteLeave (to, from, next) {

if(this.mo1){
  
  
    
  next(false);


}else{
  next(true);
}
}


  }
  </script>
  
<style>
.viptc1 .van-overlay{    z-index: 100000  !important;
}

.viptc1 .van-popup--center{z-index: 10000000 !important;}


</style>

  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped lang="less">
.viptc{
  width: 3.4rem;
  height: 3rem;
  background: url('/images/tc2.png') no-repeat ;
  background-size: contain;
}

.viptc1 .van-popup{background: none;}
  .van-notify--success {
    background-color: #07c160 !important;
}

.viptc1 .van-overlay{    z-index: 100000  !important;
}

.viptc1 .van-popup--center{z-index: 10000000 !important;}

  </style>
  